/**
 * This widget will convert a simple select list into a styled selectbox.
 * 
 * Give a select element with:
 * 
 * <select id="selectElementID">
 * 	<option value="value1">Option 1</option>
 * 	<option value="value2" selected="selected">Option 2</option>
 * </select>
 * 
 * Calling:
 * 
 * 	$('#selectElementID').selectBox({
 * 		label: 'Select something'
 * 	});
 * 
 * Options:
 * 		events			(object):	{
 * 										change:	 	(function) Called when the value is selected
 * 										open:		(function) Called when the drop down menu is opened
 * 										close:		(function) Called when the drop down menu is closed
 * 										click:		(function) Called when the button is clicked
 * 										renderItem: (function) Override for the default item rendering function. Advised against. Use "titleMode" instead.
 * 										renderMenu: (function) Override for the default menu rendering function. Advised against.
 * 									}
 * 		sourceFilter	(string):	A selector string that filters for options. Defaults to option:not(:disabled) (selects all but disabled options)
 * 		titleMode		(bool):		When set to true, the item appearing in the drop down will be the title attr of the option, while the text showing up when selected is the regular label.
 * 		noText			(string):	When an option has visible text, this is shown instead. Defaults to several non-breaking spaces.
 * 		inheritClasses	(bool):		Whether or not any classes given to the original select box should be assigned to the button.
 * 		label			(object):	{
 * 										head: (string) Label to show above the elements in a drop down. Leave blank to disable.
 * 										foot: (string) Label to show below the elements in a drop down. Leave blank to disable.
 * 										blank: (string) Label to show when the user types an element that doesn't exist. Defaults to "No item exists".
 *  								}
 *  
 *  	With the label option it alternatively accepts a single string:
 *  
 *  	label: 'My header'
 *  
 *  	This converts to:
 *  
 *  	label: {
 *  		head: 'My header',
 *  		foot: '',
 *  		blank: 'No item exists'
 *  	}	
 * 
 * Makes:
 * 	1) A button which triggers autocomplete.
 * 
 * See also http://docs.jquery.com/UI_Developer_Guide#The_widget_factory
 * 
 */
(function($){
	$.widget('ui.selectBox', {
		// Default Options
		options: {
			// Events to bind
			events: {
				change: function(event){},
				open: function(event){},
				close: function(event){},
				click: function(event){},
				renderItem: false,
				renderMenu: false,
				renderText: false,
				renderLabel: this._renderLabel
			},
			sourceFilter: 'option:not(:disabled)',
			titleMode: false,
			noText: '&nbsp;&nbsp;&nbsp;&nbsp;',
			inheritClasses: true,
			label: '',
			highlight: true,
			widgetClass: '',
			position: { my: 'left top', at: 'left bottom', collision: 'flip' },
			staticCorners: false
		},
				
		/**
		 * Called whenever the options are changed, it will fix any funky defaults
		 */
		_fixOptions: function(){
			if(typeof this.options.label != 'object'){
				this.options.label = {
					head: this.options.label,
					foot: '',
					blank: 'No item exists'
				};
			}
			else {
				this.options.label = $.extend({}, this.options.label, {
					head: this.options.label,
					foot: '',
					blank: 'No item exists'
				});
			}			

			this.options.position = $.extend({}, {
					my: 'left top', 
					at: 'left bottom', 
					collision: 'flip'
				},
				this.options.position
			);
		},
		
		/**
		 * Create the widget
		 */
		_create: function(){
			this.parentField = this.element;
			
			// Make sure this element hasn't already been created
			if(this.parentField.hasClass('select_d'))
				return true;
			
			// Fix the options
			this._fixOptions();
			
			// Mark the parent element as menu'd already
			this.parentField.addClass('select_d');
			
			// Generate the ID
			this._generateCurrentIds();
			
			// Build the elements
			this._buildElements();
			
			
			// Assign Autocomplete
			this.select.autocomplete({
				minLength: 0,
				source: this._acSourceFunction,
				position: this.options.position,
				select: function(event, ui){
					ui.item.option.selected = true;
					$(this).data('autocomplete')._trigger('selected', event, {
						item: ui.item.option
					});
					
					$(this).autocomplete('close');
					$(this).button('option', 'label', ui.item.value);
					event.calledByAutocomplete = true;
										
					// Callback Event
					if($.isFunction($(this).data('autocomplete').cbb_options.events.change))
						$(this).data('autocomplete').cbb_options.events.change(event, ui);
					
					// Trigger anything attached to the parent
					if(typeof $(this).data('autocomplete') != 'undefined')
						$(this).data('autocomplete').cbb_parentField.trigger('change', [event, ui]);
					
					if($(this).button('option', 'label').length == 0)
						$(this).button('option', 'label', $(this).data('autocomplete').cbb_getSelectedText());
				},
				close: function(event, ui){
					$(this).removeClass('ui-corner-top').addClass('ui-corner-all').removeClass('ui-state-active').blur();
					// Callback Event
					if($.isFunction($(this).data('autocomplete').cbb_options.events.close))
						$(this).data('autocomplete').cbb_options.events.close(event, ui);
					
					clearTimeout($(this).data('searchtimeout'));
				},
				open: function(event, ui){
					$(this).removeClass('ui-corner-all').addClass('ui-corner-top ui-state-active');
					// Callback Event
					if($.isFunction($(this).data('autocomplete').cbb_options.events.open))
							$(this).data('autocomplete').cbb_options.events.open(event, ui);
					
					// Scrolling
					// Find the active element
					if($(this).data('autocomplete').widget().find('li.ui-selectbox-active-item').length > 0)
						$(this).data('autocomplete').widget().scrollTo($(this).data('autocomplete').widget().find('li.ui-selectbox-active-item'));
					
					$(this).data('searchstring', '');
				}
			})
				.autocomplete('widget').addClass('selectbox-widget');
			
			this.select.autocomplete('widget').addClass(this.options.widgetClass);
			
			// Unbind default events, then bind the ones we want
			this.select.unbind('mouseover.button').unbind('mouseout.button').unbind('mouseenter.button')
				.unbind('mouseleave.button').unbind('keypress.button').unbind('keydown.button').unbind('keyup.button')
				.bind('mouseover.selectbox', function(){
					$(this).addClass('ui-state-hover');
				})
				.bind('mouseout.selectbox', function(){
					$(this).removeClass('ui-state-hover');
				})				
				.bind('click.selectbox', {clickCall:this.options.events.click, select:this.select}, function(event, ui){
					if(event.data.select.autocomplete('widget').is('.widget-space-pressed')){
						event.data.select.autocomplete('widget').removeClass('widget-space-pressed');
						return false;
					}
					
					// Call the bound event
					if($.isFunction(event.data.clickCall))
							event.data.clickCall(event, ui);
					
					$(this).addClass('ui-state-active');
					
					// When the button is clicked, show the input
					if(event.data.select.autocomplete('widget').is(':visible')){
						event.data.select.autocomplete('close');
						$(this).removeClass('ui-state-active');
						return true;
					}
					
					event.data.select.autocomplete('search', '');
					event.data.select.focus();
				})
				.bind('keydown.selectbox', {select:this.select}, function(event){
					if((event.which < 48 || event.which > 90) && event.which != 32) return;					
					if(event.which == 32)
						event.data.select.autocomplete('widget').addClass('widget-space-pressed');
					var keyPressed = String.fromCharCode(event.which);
					
					// Get the rest of the search string
					var searchString = event.data.select.data('searchstring') + keyPressed;
					
					clearTimeout(event.data.select.data('searchtimeout'));
					event.data.select.data('searchtimeout', setTimeout(function(){
						event.data.select.data('searchstring', '');
					}, 3000));
										
					// Find
					event.data.select.autocomplete('search','');
					
					// Find the new ones
					var found = event.data.select.autocomplete('widget')
					    			.find('li:startWith(' + searchString + ')');
					
					if(found.length > 0)
						event.data.select.data('searchstring', searchString);
					
					found = found.first();
					
					// Clear old ones
					event.data.select.autocomplete('widget')
					    .find('a#ui-active-menuitem').removeAttr('id');
					event.data.select.autocomplete('widget')
					    .find('a.ui-state-hover').removeClass('ui-state-hover');
					
					found.children('a').addClass('ui-state-hover')
						.attr('id', 'ui-active-menuitem');
					event.data.select.data('autocomplete').menu.active = found; 
					event.data.select.focus();
					
					event.preventDefault();
				});
				
			// Make sure the events are assigned
			this._buildSourceFunc();
			this._bindEvents();
				
		},
		
		/*
		 * Bind events tro the parent element 
		 */
		_bindEvents: function(){
			this.parentField.bind('refresh.selectbox', function(){
				$(this).selectBox('refresh');
			});
			this.parentField.bind('change.selectbox', function(){
				$(this).selectBox('refresh');
			});
		},
		
		/**
		 * Generate a unique ID for the input & button elements and store them in the this._ids object
		 */
		_generateCurrentIds: function(){
			if(this.parentField.prop('id').length == 0){
				// No attached ID, make one up
				this._ids = {
					select: 'sbox-' + ($('.select_d').length + 1) + '-select'
				};
			}
			else {
				// There is an attached ID
				this._ids = {
					select: this.parentField.attr('id') + '-select'
				};
			}
		},
		
		/**
		 * Will return the classes that should be appended to the select box based on the
		 * set options
		 * @param string elementType
		 */
		_getInheritedClasses: function(){
			if(this.options.inheritClasses == true)
				return this.parentField.attr('class');
			else
				return '';
		},
		
		/**
		 * Build the actual select element
		 */
		_buildElements: function(){
			this.select = $('<button type="button" id="' + this._ids.select + '" class="selectbox"></button>')
				.attr('title', this.parentField.prop('title'))
				.addClass(this._getInheritedClasses())
				.insertBefore(this.parentField)
				.button({
					icons: {
						secondary: 'ui-icon-triangle-1-s'
					}
				}).alerts();
			
			if(this.parentField.is('[activehelp]'))
				this.select.alerts('add', 'help', {id:'activehelp',message:this.parentField.attr('activehelp')}, false);
			
			this._setLabel(this._getSelectedText());
			this.select.data('parentField', this.parentField);
			
			if(this.parentField.is(':disabled')){
				this.disable();
			}
			
			this.parentField.hide();
		},
		
		/**
		 * Set the text of the select element
		 * @param text
		 */
		_setLabel: function(text){
			this.select.button('option', 'label', text);
		},
		
		/**
		 * Return a filter string to filter the contents of the select box
		 */
		_sourceFilter: function(){
			return this.options.sourceFilter;
		},
						
		/**
		 * Get the text of the selected element or the first element if nothing is selected
		 */
		_getSelectedText: function(){
			if(this.parentField.find(this._sourceFilter() + ':selected').length > 0){
				return this._preventBlank($('<div/>').text(this.parentField.find(this._sourceFilter() + ':selected').text()).html(), this.options.noText);
			}
			else {
				return this._preventBlank($('<div/>').text(this.parentField.find(this._sourceFilter()).text()).html(), this.options.noText);
			}
		},
		
		/**
		 * 
		 */
		_preventBlank: function(textVal, noText){			
			return ($.trim(textVal).length == 0) ? noText : textVal;
		},
	
		
		/**
		 * Will build & assign the source filter function to autocomplete
		 */
		_buildSourceFunc: function(){
			// Assign the information to the autocomplete box
			this.select.data('autocomplete').cbb_parentField = this.parentField; // jQuery Object
			this.select.data('autocomplete').cbb_sourceFilter = this._sourceFilter(); // Function returning string
			this.select.data('autocomplete').cbb_options = this.options; // Function or Bool filtering
			this.select.data('autocomplete').cbb_getSelectedText = this._acGetSelectedText; // Function or Bool filtering
			this.select.data('autocomplete').cbb_preventBlank = this._preventBlank; // Function or Bool filtering
			this.select.data('autocomplete').cbb_fixRender = this._fixRenderedClasses; // Function
			this.select.data('autocomplete')._renderMenu = ($.isFunction(this.options.events.renderMenu)) ? this.options.events.renderMenu : this._acRenderMenu;
			this.select.data('autocomplete')._renderItem = ($.isFunction(this.options.events.renderItem)) ? this.options.events.renderItem : this._acRenderItem;
			this.select.data('autocomplete')._renderText = ($.isFunction(this.options.events.renderText)) ? this.options.events.renderText : this._acRenderText;
		},
		
		/**
		 * Autocomplete Source Function
		 */
		_acSourceFunction: function(request, response){
			// Scope of Autocomplete
			var matcher = new RegExp( $.ui.autocomplete.escapeRegex(request.term), "i" );
			
			this.cbb_parentField.find('optgroup').each(function(){
			if($(this).find('option').length == 0)
				$(this).append('<option class="skipme"></option>');
			});
			
			var options = this.cbb_parentField.find(this.cbb_sourceFilter);
			var responseObject = [];
			options.each(function(){
				var text = $('<div/>').text($(this).text()).html();
				
				if($(this).attr('style')){
					text = '<span style="' + $(this).attr('style') + '">' + text + '</span>'; 
				}
				
				responseObject.push({
					label: text,
					value: text,
					option: this,
					category: $(this).parent('optgroup').attr('label'),
					title: $(this).attr('title'),
					skipme: $(this).is('.skipme'),
					help: $(this).is('[activehelp]') ? $(this).attr('activehelp') : '',
					data: $(this).data()
				});
				
				
			});
			
			response(responseObject);
		},
		
		/**
		 * Get the text of the selected element or the first element if nothing is selected
		 */
		_acGetSelectedText: function(){
			if(this.cbb_parentField.find(this.cbb_sourceFilter + ':selected').length > 0){
				return this.cbb_preventBlank(this.cbb_parentField.find(this.cbb_sourceFilter + ':selected').text(), this.cbb_options.noText);
			}
			else {
				return this.cbb_preventBlank(this.cbb_parentField.find(this.cbb_sourceFilter).text(), this.cbb_options.noText);
			}
		},
		
		/**
		 * Autocomplete Menu Rendering Function
		 * @param ul
		 * @param items
		 */
		_acRenderMenu: function(ul, items){		
			// Scope of Autocomplete
			var self = this;
			var currentCategory = undefined;
			$.each(items, function(index, item){
				if(currentCategory != item.category){
					if(item.category != undefined)
						$('<li class="ui-autocomplete-category nolab">' + item.category + '</li>').appendTo(ul);
					currentCategory = item.category;
				}
				if($.trim(item.label).length == 0)
					item.label = '&nbsp;';
				
				if(!item.skipme)
					self._renderItem(ul, item);
			});
			
			if(this.cbb_options.label.head.length > 0)
				$('<li class="autoheader nolab">' + this.cbb_options.label.head + '</li>').prependTo(ul);
			
			if(this.cbb_options.label.foot.length > 0)
				$('<li class="autoheader nolab">' + this.cbb_options.label.foot + '</li>').appendTo(ul);
			
			if(!this.cbb_options.staticCorners){
				ul.removeClass('ui-corner-all')
					.addClass('ui-corner-bottom');
			}
		},
		
		/**
		 * Autocomplete Item Rendering Function
		 * @param ul
		 * @param item
		 */
		_acRenderItem: function(ul, item){
			// Scope of Autocomplete
			var thisClass = item.option.selected && this.cbb_options.highlight ? 'ui-selectbox-active-item' : '',
				itemClass = $(item.option).attr('class');

			if(this.cbb_options.inheritClasses === true && typeof itemClass !== 'undefined')
			{
				thisClass += ' ' + itemClass;
			}

			if(this.cbb_options.titleMode){
				return $('<li class="ui-selectbox--item"' + (item.help.length > 0 ? ' activehelp="' + item.help + '"' : '') + '></li>')
					.data('item.autocomplete', item)
					.addClass(thisClass)
					.append('<a>' + item.title + '</a>')
					.appendTo(ul);
			}
			else {
				return $('<li class="ui-selectbox--item"' + (item.help.length > 0 ? ' activehelp="' + item.help + '"' : '') + '></li>')
					.data('item.autocomplete', item)
					.addClass(thisClass)
					.append(this._renderText(item))
					.appendTo(ul);
			}
		},
		
		_acRenderText: function(item){
			return '<a>' + item.label + '</a>';
		},
		
		_renderLabel: function(option){
			return this._preventBlank($('<div/>').text(option.text()).html(), this.options.noText);
		},
		
		_isOpen: function(){
			return this.select.autocomplete('widget').is(':visible');
		},
		
		// Public functions
		
		/**
		 * Refresh the Element
		 */
		refresh: function(){
			this._fixOptions();
			this._buildSourceFunc();
			this.select.autocomplete('widget').addClass(this.options.widgetClass);
			
			var renderLabelFunction = this.options.events.renderLabel;
			if(!renderLabelFunction) renderLabelFunction = this._renderLabel;
			var item = this.parentField.find(this._sourceFilter() + ':selected');
			if(item.length == 0 && this.cbb_parentField) item = this.cbb_parentField.find(this.cbb_sourceFilter);
			this._setLabel(renderLabelFunction.call(this, item));
			
			if(this._isOpen()){
				this.select.autocomplete('close').autocomplete('search', '').focus();
			}
			
			if(this.parentField.is(':disabled')){
				this.disable();
			}
			else {
				this.enable();
			}
			
			this.select.autocomplete('refresh').button('refresh');
		},
		
		/**
		 * Close the box if open
		 */
		close: function(){
			if(this.select.autocomplete('widget').is(':visible')){
				this.select.autocomplete('close');
			}
		},
		
		/**
		 * Open the box if closed
		 */
		open: function(){
			if(!this.select.autocomplete('widget').is(':visible')){
				this.select.autocomplete('search', '').focus();
			}
		},
		
		/**
		 * Disable the select box
		 */
		disable: function(){
			this.close();
			this.select.attr('disabled', 'disabled').addClass('disabled').autocomplete('refresh').button('refresh');
			this.parentField.attr('disabled', 'disabled').addClass('disabled');
			this.element.addClass('disable-field-alert');
			this.select.alerts('hide');
		},
		
		/**
		 * Enable the select box
		 */
		enable: function(){
			this.select.removeAttr('disabled').removeClass('disabled').autocomplete('refresh').button('refresh');
			this.parentField.removeAttr('disabled').removeClass('disabled');
			this.element.removeClass('disable-field-alert');
		},
		
		/**
		 * Gets the value of the select box
		 * @returns mixed
		 */
		val: function(){
			return this.parentField.find('option:selected').val();
		},
		
		/**
		 * Calls this.val to get the current value
		 */
		getValue: function(){
			return this.val();
		},
		
		/**
		 * Get the button
		 * @returns
		 */
		get: function(){
			return this.select;
		},
		
		/**
		 * Gets the dropdown widget
		 * @returns
		 */
		widget: function(){
			return this.select.autocomplete('widget');
		},
		
		/**
		 * Hide/Show the parent box
		 */
		toggleSelect: function(){
			this.parentField.toggle();
		},
		
		/**
		 * Destroy the select box widget
		 */
		destroy: function(){
			// Cal widget destroy function
			$.Widget.prototype.destroy.apply(this, arguments);
			this.select.remove();
			this.parentField.removeClass('select_d').show();
		}
	});
})( jQuery );